{
  "analyse": {
    "title": "Digitise a site",
    "intro": "Classify a site from a satellite capture and get a report.",
    "site": "Site",
    "noSites": "Save a site boundary on the map first, then analyse it here.",
    "capture": "Capture",
    "loadingCaptures": "Finding captures…",
    "noCaptures": "No capture covers this site yet.",
    "capturedOn": "Captured {{date}}",
    "captureDetail": "{{label}} · {{provider}} · {{gsd}} m per pixel",
    "analytics": "Model",
    "names": {
      "land_cover": "Land cover",
      "buildings": "Buildings",
      "green_water": "Green & water",
      "roads_paved": "Roads & paved"
    },
    "run": "Run analysis",
    "running": "Analysing…",
    "queued": "Waiting to start…",
    "compared": "Compared with this site's previous report.",
    "done": "Analysis complete.",
    "viewReport": "Open report",
    "failed": "The analysis did not finish.",
    "tryAgain": "Try again",
    "showOnMap": "Show on map",
    "hideOnMap": "Hide from map",
    "duration": "Finished in {{duration}}",
    "captureOption": "{{date}} · {{provider}} · {{gsd}} m"
  },
  "page": {
    "title": "Site report",
    "back": "Back to workspace",
    "print": "Print",
    "captured": "Captured {{date}}",
    "generated": "Generated {{date}}",
    "model": "Model {{version}}",
    "processed": "Processed in {{duration}}",
    "preparedFor": "Prepared for {{organisation}}",
    "unsupported": "This report was written in a newer format than this page can show. Reload to update.",
    "figures": {
      "siteArea": "Site area",
      "buildings": "Buildings",
      "greenWater": "Green & water",
      "roadsPaved": "Roads & paved",
      "ofSite": "{{pct}}% of site",
      "coverage": "{{pct}}% of site covered"
    },
    "landCover": {
      "title": "Land cover",
      "class": "Class",
      "area": "Area (ha)",
      "share": "Share",
      "patches": "Patches"
    },
    "change": {
      "title": "Change since {{date}}",
      "titleUndated": "Change since the previous report",
      "none": "This is the first report for this site, so there is nothing to compare with yet.",
      "before": "Before (ha)",
      "now": "Now (ha)",
      "delta": "Change (ha)",
      "deltaShare": "Change (pts)",
      "buildings": "Buildings: {{before}} → {{after}}"
    },
    "buildings": {
      "title": "Buildings",
      "count": "Buildings",
      "footprint": "Total footprint",
      "median": "Median size",
      "largest": "Largest",
      "density": "Per hectare"
    },
    "map": "Map",
    "downloads": {
      "title": "Downloads",
      "classification_cog": "Classification (GeoTIFF)",
      "report_data": "Report data (JSON)",
      "report_pdf": "Site report (PDF)",
      "export_bundle": "GIS files (ZIP)",
      "download": "Download"
    },
    "method": "Areas are measured in {{crs}}, the site's local survey grid. Classified area {{classified}} ha of the site's surveyed {{site}} ha. Classification by {{model}}.",
    "history": {
      "title": "Report history",
      "current": "This report"
    }
  },
  "flow": {
    "label": "Digitise steps",
    "steps": {
      "area": "Area",
      "capture": "Capture",
      "analytics": "Analytics",
      "run": "Run",
      "report": "Report"
    },
    "areaHint": "Choose a saved site. To add one, draw a boundary on the map.",
    "siteArea": "{{area}} ha · {{crs}}",
    "model": "Land cover map (8 classes)",
    "modelHint": "One pass of the model. The report covers every class, with buildings, green and water, and roads and paved areas.",
    "describe": {
      "land_cover": "Every class, its area and share of the site.",
      "buildings": "Footprints, their count, sizes and coverage.",
      "green_water": "Trees, grass, agriculture and water.",
      "roads_paved": "Roads and paved surfaces."
    },
    "cancel": "Cancel run",
    "cancelled": "The run was cancelled.",
    "retry": "Retry",
    "startAgain": "Start a new analysis",
    "runNeeds": "Choose a site, a capture and at least one analytic to run.",
    "runIdle": "Choose a site, a capture and at least one analytic above, then press Run analysis.",
    "runReady": "Ready to run on {{summary}}. Press Run analysis below; progress shows here.",
    "runDone": "Analysis finished. Its report is below, and you can run it again.",
    "reportEmpty": "Run an analysis to see its report here."
  },
  "dock": {
    "title": "Runs",
    "empty": "No runs yet. Start one from the Analyse or Design tab.",
    "status": {
      "queued": "Queued",
      "running": "Running",
      "succeeded": "Succeeded",
      "failed": "Failed",
      "cancelled": "Cancelled",
      "rejected": "Not started",
      "dead_letter": "Failed"
    },
    "elapsed": "Time elapsed",
    "report": "Report",
    "show": "Show",
    "cancel": "Cancel",
    "retry": "Retry",
    "site": "{{site}} · {{date}}",
    "kind": {
      "analysis.lulc": "Land cover",
      "analysis.generate": "AI analysis",
      "simulation.generate": "Design"
    },
    "run": "{{kind}} · {{site}} · {{date}}"
  },
  "time": {
    "seconds": "{{s}} s",
    "minutes": "{{m}} min {{s}} s",
    "hours": "{{h}} h {{m}} min"
  },
  "layers": {
    "title": "Results",
    "item": "Land cover",
    "opacity": "Opacity {{pct}}%",
    "legend": "Land cover — select a class to hide it",
    "imagery": {
      "title": "Imagery",
      "detail": "{{label}} · {{gsd}} m"
    },
    "aiItem": "AI analysis",
    "legendAi": "AI analysis — select a class to hide it",
    "collapse": "Fold away",
    "expand": "Show"
  },
  "upload": {
    "title": "Or upload a boundary file",
    "hint": "GeoJSON, KML or a zipped Shapefile (with its .prj), up to 5 MB.",
    "browse": "Choose a file",
    "compactTitle": "Upload a boundary file",
    "compactHint": "GeoJSON, KML or zipped Shapefile · max 5 MB",
    "tooLarge": "That file is larger than 5 MB.",
    "reading": "Reading the file…",
    "found": "{{count}} polygon(s) · {{area}} ha · measured in EPSG:{{crs}}",
    "fileCrs": "File CRS: EPSG:{{crs}}",
    "name": "Site name",
    "save": "Save as a site",
    "discard": "Discard"
  },
  "schedule": {
    "title": "Scheduled reports",
    "none": "This site's report is not scheduled.",
    "active": "{{frequency}} · next check {{date}}",
    "frequency": "How often",
    "frequencies": {
      "once": "Only once",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "quarterly": "Quarterly"
    },
    "every": {
      "weekly": "Every week",
      "monthly": "Every month",
      "quarterly": "Every quarter"
    },
    "onceNote": "This report runs once, when you run the analysis.",
    "start": "Schedule this report",
    "update": "Save changes",
    "stop": "Stop the schedule",
    "failed": "The schedule could not be saved.",
    "imageryNote": "A new report needs a newer capture than the last one. When none is available, you'll get a notice instead.",
    "scheduled": "Scheduled",
    "lastCheck": {
      "started": "Last check, {{date}}: a {{captured}} capture was newer, so a new report was made.",
      "no_new_imagery": "Last check, {{date}}: nothing newer than the {{captured}} capture yet, so no new report.",
      "refused": "Last check, {{date}}: a newer capture was found, but the report could not start."
    }
  },
  "imagery": {
    "title": "Newer imagery",
    "getNewer": "Get newer imagery",
    "hint": "Captures of this site from Esri's archive. Getting one copies it into your council's storage; it then appears above and can be analysed.",
    "searching": "Searching for captures…",
    "none": "No captures cover this site.",
    "unavailable": "Imagery search is unavailable right now.",
    "detail": "{{source}} · {{resolution}} m",
    "unknownSource": "Esri",
    "get": "Get this capture",
    "retry": "Try again",
    "ready": "Ready",
    "status": {
      "pending": "Queued",
      "acquiring": "Acquiring",
      "copying": "Copying",
      "ready": "Ready",
      "failed": "Failed"
    },
    "panel": {
      "noSites": "Draw or upload a site first; imagery is searched over a site.",
      "providers": "Providers",
      "provider": {
        "esri": "Esri World Imagery",
        "google": "Google Satellite",
        "sentinel-2": "Sentinel-2",
        "landsat": "Landsat"
      },
      "mosaic": "Up to {{max}} ha",
      "sensor": "{{resolution}} m · up to {{max}} ha",
      "available": "Available",
      "reason": {
        "not_configured": "Not set up",
        "site_too_small": "Site too small",
        "site_too_large": "Site too large"
      },
      "noProvider": "No provider can serve this site.",
      "pickProvider": "Pick a provider to search for imagery.",
      "search": "Search",
      "latest": "Latest image",
      "latestNote": "Google gives only its current image, with no capture date.",
      "dates": "Captured",
      "maxCloud": "Max cloud cover",
      "percent": "{{value}}%",
      "cloudCover": "Cloud cover {{value}}%",
      "showMore": "Show more ({{count}} left)",
      "preview": "Preview on the map",
      "previewStop": "Hide the preview",
      "previewState": {
        "loading": "Loading the preview…",
        "shown": "Preview on the map",
        "failed": "No preview for this capture"
      },
      "preset": {
        "all": "All",
        "5y": "5 years",
        "1y": "1 year",
        "90d": "90 days",
        "30d": "30 days",
        "custom": "Custom"
      },
      "from": "From",
      "to": "To",
      "results_one": "{{count}} capture",
      "results_other": "{{count}} captures",
      "sort": "Sort captures",
      "sortBy": {
        "newest": "Newest first",
        "oldest": "Oldest first",
        "sharpest": "Sharpest first"
      },
      "sources": "Filter by source",
      "chosen_one": "{{count}} of 2 chosen to compare",
      "chosen_other": "{{count}} of 2 chosen to compare",
      "compare": "Compare",
      "show": "Show",
      "analyse": "Analyse",
      "notAnalysable": "Too coarse for land cover: it needs 0.7 m per pixel or finer",
      "download": "Download the GeoTIFF",
      "pick": "Compare",
      "incomplete": "Some captures are not listed: their dates could not be read just now.",
      "searchAgain": "Search again"
    }
  },
  "compare": {
    "title": "Compare captures",
    "close": "Close the comparison",
    "mode": "Comparison mode",
    "modes": {
      "swipe": "Swipe",
      "side": "Side by side",
      "blend": "Blend"
    },
    "divider": "Move the divider",
    "blend": "Newer capture {{pct}}%",
    "loading": "Loading the captures…",
    "failed": "The captures could not be loaded.",
    "resultsTitle": "Compare land cover"
  },
  "documents": {
    "title": "Reports",
    "noSites": "Draw or upload a site first; reports are made from an analysis of a site.",
    "none": "No analyses of this site yet. Every report is made from one — run an analysis in the Analyse tab first.",
    "goAnalyse": "Go to Analyse",
    "loadFailed": "The reports could not be loaded.",
    "analysis": "Analysis of {{date}}",
    "analysisUndated": "Analysis (capture date not recorded)",
    "compared": "Compared with {{date}}",
    "comparedEarlier": "Compared with an earlier analysis",
    "firstAnalysis": "First analysis of this site",
    "scheduled": "Scheduled",
    "open": "Open report",
    "pdf": "PDF",
    "bundle": "GIS files",
    "make": "Make a report",
    "made_one": "{{count}} report made from this analysis",
    "made_other": "{{count}} reports made from this analysis",
    "document": "{{paper}} {{orientation}} · version {{version}}",
    "download": "Download PDF",
    "status": {
      "queued": "Queued",
      "running": "Printing…",
      "succeeded": "Ready",
      "failed": "Failed",
      "cancelled": "Cancelled"
    },
    "template": {
      "site_analysis": "Site Analysis",
      "change_detection": "Change Detection",
      "discrepancy": "Discrepancy / Enforcement",
      "development_proposal": "Development Proposal"
    },
    "templateHint": {
      "site_analysis": "Land cover, buildings and the capture, for one date.",
      "change_detection": "What changed since the analysis this one was compared with, first.",
      "discrepancy": "Where land use differs from the cadastre, for enforcement.",
      "development_proposal": "Simulated development options and their metrics."
    },
    "section": {
      "cover": "Cover",
      "site_summary": "Site summary",
      "classification": "Land cover map and statistics",
      "change": "Change since the earlier analysis",
      "imagery": "Imagery used",
      "methodology": "Methodology",
      "discrepancy": "Discrepancy table",
      "simulation": "Simulation options and metrics",
      "compliance": "Compliance results",
      "annotations": "Annotations",
      "appendix": "Appendix: provenance and run IDs"
    },
    "reason": {
      "no_analysis": "Needs an analysis of the site",
      "no_earlier_report": "Needs an analysis compared with an earlier one",
      "needs_cadastre_comparison": "Needs the cadastre comparison, not built yet",
      "needs_simulation": "Needs a simulation, not built yet",
      "needs_compliance": "Needs the rulebook check, not built yet",
      "needs_annotations": "Needs annotations, not built yet"
    },
    "required": "Always included",
    "templates": "Template",
    "sections": "Sections",
    "paper": "Paper",
    "orientation": "Orientation",
    "portrait": "Portrait",
    "landscape": "Landscape",
    "submit": "Make report",
    "cancel": "Cancel",
    "loadingTemplates": "Loading templates…",
    "startFailed": "The report could not be started. Please try again.",
    "quota": "Your organisation has no credits left this period.",
    "ran": "Run {{date}}",
    "pick": "Compare",
    "chosen_one": "{{count}} of 2 chosen to compare",
    "chosen_other": "{{count}} of 2 chosen to compare",
    "compareChosen": "Compare land cover",
    "compareWith": "Compare with {{date}}",
    "compareWithEarlier": "Compare with the earlier analysis",
    "landCover": "Land cover",
    "compareFailed": "The comparison could not be opened.",
    "aiAnalysis": "{{label}} · {{date}}",
    "aiAnalysisUndated": "{{label}}",
    "aiBadge": "AI analysis",
    "aiFallback": "AI analysis"
  },
  "generate": {
    "captureOption": "{{date}} · {{provider}} · {{gsd}} m",
    "tier": "Output size",
    "tierAuto": "Automatic",
    "tiers": {
      "1K": "1K (about 1,000 px)",
      "2K": "2K (about 2,000 px)",
      "4K": "4K (about 4,000 px)"
    },
    "failed": "The image could not be made. Try again.",
    "made": "{{width}} × {{height}} px",
    "aiNote": "Made by an AI model.",
    "show": "Show",
    "hide": "Hide",
    "download": "GeoTIFF",
    "opacity": "Opacity {{pct}}%",
    "earlier": "Earlier images",
    "subject": "What to look for",
    "subjectPlaceholder": "cars, swimming pools, solar panels",
    "pictureHint": "An AI analysis of the chosen capture, drawn on the map as a picture.",
    "done": "Analysis complete. The picture is on the map.",
    "runDone": "Analysis finished. The picture is on the map, and you can run it again.",
    "view": {
      "label": "What to show",
      "polygons": "Polygons",
      "picture": "Picture"
    },
    "areas": "Area by class",
    "classHa": "{{area}} ha",
    "classShare": "{{pct}}%",
    "report": "Report (PDF)",
    "measured": "{{area}} ha mapped inside the site boundary",
    "fit": {
      "tooLarge": "This site is too large for this analysis with this capture. It can be up to about {{max}} m across.",
      "tooSmall": "This site is too small for this analysis.",
      "tooLargeModel": "This site is too large for the land-cover model with this capture.",
      "noneFits": "This site does not fit the chosen analysis. Choose another, or a smaller site.",
      "someUnfit": "Greyed-out analyses cannot work on a site this size with this capture."
    }
  }
}
